import { useEntitlements, usePermission } from '@restaurant/api-client';

/**
 * Whether this till shows guests at all: the plan sells them, and the role
 * reads them. Apart from `guest.tsx` so that file exports only components.
 */
export function useGuestsOnTill(): boolean {
  const entitlements = useEntitlements();
  const mayRead = usePermission('customers.guest.read');
  return entitlements.has('customers.core') && mayRead;
}

/**
 * Whether this till shows points: guests are on, and the plan sells points.
 * Spending them is a permission of its own (`customers.loyalty.redeem`).
 */
export function usePointsOnTill(): boolean {
  const guestsOn = useGuestsOnTill();
  const entitlements = useEntitlements();
  return guestsOn && entitlements.has('customers.loyalty.points');
}
